/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Avatar, CardHeader, Divider, Badge } from '@mui/material';
import { styled } from '@mui/material/styles';
import { connect } from 'react-redux';
import ErrorBoundary from '../../components/error_boundary';
import * as common from '../../appRedux/actions/common';
import * as field from '../../appRedux/actions/field';
import * as info from '../../appRedux/actions/info';
import IntlMessages from '../../util/IntlMessages';
import Pido from '../../assets/images/pido.png';
import WorkingStatus from './working_status';
import TankerProbe from './TankerProbe';

function HomePage(props) {
  let iOnlineStatus = props.field.profile.iOnlineStatus;
  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      backgroundColor:
        iOnlineStatus === 0 ? theme.palette.primary.main : theme.palette.color.green,
      color: iOnlineStatus === 0 ? theme.palette.primary.main : theme.palette.color.green,
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        animation: 'ripple 1.2s infinite ease-in-out',
        border: '5px solid currentColor',
        content: '""',
      },
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0,
      },
    },
  }));

  useEffect(() => {
    props.setFields([{ data: [], field: 'list' }]);
    props.operatorProfileAction();
    if (!props.menu) props.menuAction(true);
  }, []);

  const getScore = () => {
    return (
      <>
        <IntlMessages id="yourScore" /> : {props.field.profile.iDriverScore}
      </>
    );
  };

  return (
    <React.Fragment>
      <ErrorBoundary>
        <CardHeader
          avatar={
            <StyledBadge
              overlap="circular"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              variant="dot"
            >
              <Avatar alt="Pido" src={Pido} />
            </StyledBadge>
          }
          action={<WorkingStatus />}
          title={
            props.field.profile.vFirstname +
            ' ' +
            props.field.profile.vLastname +
            ' ( ' +
            props.field.profile.vFuelCarCode +
            ' ) '
          }
          subheader={getScore()}
        />
        <Divider />
        <TankerProbe />
      </ErrorBoundary>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    field: state.field,
    list: state.field.list,
    menu: state.common.menu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFields: (data) => dispatch(field.setFields(data)),
    menuAction: (data) => dispatch(common.menuAction(data)),
    operatorProfileAction: () => dispatch(info.operatorProfileAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
